import React from 'react'
import { Link } from 'react-router-dom'

import bg from '../assets/images/hero/auth.jpg'
import logoDark from '../assets/images/logo-dark.png'
import logoLight from '../assets/images/logo-white.png'


export default function Signup() {
  return (
    <>
        <section className="bg-home d-flex align-items-center" style={{backgroundImage:`url(${bg})`, backgroundPosition:'center'}}>
            <div className="bg-overlay bg-linear-gradient-2"></div>
            <div className="container">
                <div className="row justify-content-end">
                    <div className="col-lg-4 col-md-6 col-12">
                        <div className="p-4 bg-white rounded shadow-md mx-auto w-100" style={{maxWidth:'400px'}}>
                            <form>
                                <Link to="/"><img src={logoDark} className="mb-4  mx-auto logo-light" alt=""/></Link>
                                <Link to="/"><img src={logoLight} className="mb-4  mx-auto logo-dark" alt=""/></Link>
                                <h6 className="mb-3 text-uppercase fw-semibold">Register your account</h6>
                            
                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Your Name</label>
                                    <input name="name" id="name" type="text" className="form-control" placeholder="Calvin Carlo"/>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Your Email</label>
                                    <input name="email" id="email" type="email" className="form-control" placeholder="example@website.com"/>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label fw-semibold" htmlFor="loginpass">Password</label>
                                    <input type="password" className="form-control" id="loginpass" placeholder="Password"/>
                                </div>
                            
                                <div className="form-check mb-3">
                                    <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                                    <label className="form-label form-check-label text-muted" htmlFor="flexCheckDefault">I Accept <Link to="#" className="text-primary">Terms And Condition</Link></label>
                                </div>
                
                                <button className="btn btn-primary w-100" type="submit">Register</button>

                                <div className="col-12 text-center mt-3">
                                    <span><span className="text-muted small me-2">Already have an account ? </span> <Link to="/login" className="text-dark fw-semibold small">Sign in</Link></span>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}
